import React, { useEffect, useRef, useState } from 'react';

declare global {
    interface Window {
        adsbygoogle: any;
    }
}

export enum DataAdLayout {
    IN_ARTICLE = 'in-article',
    IN_FEED = 'in-feed'
}

export enum AdSenseFormat {
    AUTO = 'auto',
    RECTANGLE = 'rectangle',
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
    LEADERBOARD = 'leaderboard',
    SKYSCRAPER = 'skyscraper',
    LARGE_RECTANGLE = 'large_rectangle',
    RESPONSIVE = 'responsive',
    FLUID = 'fluid',
    LINK_UNIT = 'link_unit',
    AUTO_RELAXED = 'auto_relaxed',
}

interface AdSenseProps {
    client: string; // ID de cliente de AdSense
    slot: string; // ID de slot de AdSense
    dataAdLayout?: DataAdLayout;
    format: AdSenseFormat; // Formato de anuncio de AdSense
    dataFullWidthResponsive: boolean; // Formato de anuncio de AdSense
}

const GoogleAds: React.FC<AdSenseProps> = ({ client, slot, format, dataFullWidthResponsive, dataAdLayout }) => {
    const adRef = useRef<HTMLDivElement>(null);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!mounted) return;
        const el = adRef.current;
        if (!el) return;

        const width = el.offsetWidth;
        if (width && width > 0) {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                // Silenciar errores de reinicialización
            }
        } else {
            const onResize = () => {
                const w = el.offsetWidth;
                if (w > 0) {
                    try {
                        (window.adsbygoogle = window.adsbygoogle || []).push({});
                    } catch {}
                    window.removeEventListener('resize', onResize);
                }
            };
            window.addEventListener('resize', onResize);
            return () => window.removeEventListener('resize', onResize);
        }
    }, [mounted]);

    return (
        <div ref={adRef} style={{ width: '100%' }}>
            <ins
                className="adsbygoogle"
                style={{ display: 'block', minHeight: '100px' }}
                data-ad-client={client}
                data-ad-layout={dataAdLayout}
                data-ad-slot={slot}
                data-ad-format={format}
                data-full-width-responsive={dataFullWidthResponsive}
            />
        </div>
    );
};

export default GoogleAds;
